export default __webpack_public_path__ + "static/media/ic_company_blue_48px.c0489305.svg";